import React from 'react';

import { AccessTab } from '../CompanyProfileTabs/AccessTab';
import { DocumentsTab } from '../CompanyProfileTabs/DocumentsTab';
import { RepresentativesTab } from '../CompanyProfileTabs/RepresentativesTab';

interface GetTabByCodeParams {
  isAllowEdit: boolean;
  code: string;
}

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    className: 'root-company-profile-tabs__tab',
  };
}

export function getTabByCode(params: GetTabByCodeParams): React.ReactNode {
  switch (params.code) {
    case 'documents':
      return <DocumentsTab isAllowEdit={params.isAllowEdit} />;
    case 'representatives':
      return <RepresentativesTab />;
    case 'access':
      return <AccessTab />;
    default:
      return <></>;
  }
}
